import { ReducerBuilder } from "../../utils/redux/reducer-builder";
import {
  ApplicationActionTypes,
  ApplicationState,
  CompanyLanguage,
} from "../application/application-types";

import { INITIAL_STATE } from "./application-types";

const reduxBuilder = new ReducerBuilder<ApplicationState>(INITIAL_STATE);


reduxBuilder.addMutableReducer<string>(
  ApplicationActionTypes.CHANGE_COMPANY_LANGUAGE,
  (state) => {
    state.companyLanguage.data = null;
    state.companyLanguage.loading = true;
  }
);

reduxBuilder.addMutableReducer<CompanyLanguage>(
  ApplicationActionTypes.CHANGE_COMPANY_LANGUAGE_SUCCESS,
  (state, payload) => {
    state.companyLanguage.loading = false;
    state.companyLanguage.data = payload;
  }
);

reduxBuilder.addMutableReducer<string>(
  ApplicationActionTypes.CHANGE_COMPANY_LANGUAGE_ERROR,
  (state, payload) => {
    state.companyLanguage.loading = false;
    state.companyLanguage.error = payload;
  }
);

reduxBuilder.addMutableReducer<string>(
  ApplicationActionTypes.CHANGE_USER_LANGUAGE_SUCCESS,
  (state, data) => {
    window.sessionStorage.setItem("i18n", data);
  }
);

reduxBuilder.addMutableReducer<string>(
  ApplicationActionTypes.CHANGE_COMPANY_CURRENCY,
  (state) => {
    state.companyCurrency.data = null;
    state.companyCurrency.loading = true;
  }
);

reduxBuilder.addMutableReducer<CompanyLanguage>(
  ApplicationActionTypes.CHANGE_COMPANY_CURRENCY_SUCCESS,
  (state, payload) => {
    state.companyCurrency.loading = false;
    state.companyCurrency.data = payload;
  }
);

reduxBuilder.addMutableReducer<string>(
  ApplicationActionTypes.CHANGE_COMPANY_CURRENCY_ERROR,
  (state, payload) => {
    state.companyCurrency.loading = false;
    state.companyCurrency.error = payload;
  }
);


export default reduxBuilder.build();
